import { useRouter } from '@tanstack/react-router';

/**
 * Builds the href of a user page, for real `<a>` links (open in a new tab,
 * middle click, copy link address) next to the usual `navigate()` picks.
 * Goes through the router rather than a template string so a basepath or a
 * rewrite is honoured.
 */
export function useUserPageHref() {
  const router = useRouter();
  return (oid: string) =>
    router.buildLocation({ to: '/users/$oid', params: { oid } }).href;
}
